import styled, { css } from "styled-components";
import { Group as GroupPrimitive } from "react-aria-components";
import { useDesignTokens } from "@boi/react-design-tokens";

import { TextInputV2 } from "../TextInputV2";

export const Group = styled(GroupPrimitive)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { spacing } = tokens;

    return css`
      display: inline-flex;
      gap: ${spacing.s16};
    `;
  }}
`;

export const InputAlertsContainer = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { spacing } = tokens;

    return css`
      display: grid;
      gap: ${spacing.s4};
    `;
  }}
`;

export const TwoCharacterTextInput = styled(TextInputV2).attrs({
  inputmode: "numeric",
  maxLength: 2,
})`
  width: 60px;
`;

export const FourCharacterTextInput = styled(TextInputV2).attrs({
  inputmode: "numeric",
  maxLength: 4,
})`
  width: 88px;
`;
